/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSortedLocationsByPlanDateQueryResult } from '../../models/get-sorted-locations-by-plan-date-query-result';

export interface ApiLocationGetSortedLocationsByPlanDateGet$Plain$Params {
  DistrictId?: string;
}

export function apiLocationGetSortedLocationsByPlanDateGet$Plain(http: HttpClient, rootUrl: string, params?: ApiLocationGetSortedLocationsByPlanDateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSortedLocationsByPlanDateQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiLocationGetSortedLocationsByPlanDateGet$Plain.PATH, 'get');
  if (params) {
    rb.query('DistrictId', params.DistrictId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSortedLocationsByPlanDateQueryResult>;
    })
  );
}

apiLocationGetSortedLocationsByPlanDateGet$Plain.PATH = '/api/Location/GetSortedLocationsByPlanDate';
